<template lang="pug">
.container.grid-lg.my-2.py-2
  fieldset(:disabled="loading")
    form(@submit.prevent="save")
      .panel
        .panel-header
          .h5 Novo Cadastro Restrito
        .panel-body.columns
          form-group.column.col-12(:label="'cadastro_protegido.cadastro' | tModel" :validation="$v.form.cadastro_id")
            cadastro-picker(v-model="$v.form.cadastro_id.$model")
          form-group.column.col-12(:label="'cadastro_protegido.doc_modelo' | tModel" :validation="$v.form.doc_modelo_id")
            doc-modelo-picker(v-model="$v.form.doc_modelo_id.$model")
          form-group.column.col-3.col-sm-12(:label="'cadastro_protegido.inicia_em' | tModel" :validation="$v.form.inicia_em")
            datepicker(v-model="$v.form.inicia_em.$model")
          form-group.column.col-3.col-sm-12(:label="'cadastro_protegido.termina_em' | tModel" :validation="$v.form.termina_em")
            datepicker(v-model="$v.form.termina_em.$model")
          form-group.column.col-12(:label="'cadastro_protegido.descricao' | tModel" :validation="$v.form.descricao")
            input.form-input(v-model="$v.form.descricao.$model" type="text")
          form-group.column.col-3.col-sm-12(:label="'cadastro_protegido.protocolo_numero' | tModel" :validation="$v.form.protocolo_numero")
            int.form-input(v-model="$v.form.protocolo_numero.$model")
          form-group.column.col-3.col-sm-12(:label="'cadastro_protegido.protocolo_ano' | tModel" :validation="$v.form.protocolo_ano")
            year.form-input(v-model="$v.form.protocolo_ano.$model")
        .panel-footer.text-right
          button.btn.btn-primary(:disabled="$v.$invalid || loading" :class="loading") Salvar
</template>

<script>
import { required } from "vuelidate/lib/validators"
import toastErrors from "@/lib/errors/toastErrors"

export default {
  vuex: {
    cadastroProtegidos: {
      getters: ["loading"],
      actions: ["fetchCreate"],
    },
  },
  data() {
    return {
      form: {
        cadastro_id: null,
        doc_modelo_id: null,
        inicia_em: null,
        termina_em: null,
        protocolo_numero: 0,
        protocolo_ano: 0,
        descricao: "",
      },
    }
  },
  methods: {
    async save() {
      try {
        await this.fetchCreate({ ...this.form })
        this.$toaster.success("Salvo com sucesso")
        this.$router.replace({ name: "app.cadastroProtegidos" })
      } catch (e) {
        toastErrors(e)
      }
    },
  },
  validations() {
    return {
      form: {
        cadastro_id: { required },
        doc_modelo_id: { required },
        descricao: { required },
        protocolo_numero: {},
        protocolo_ano: {},
        inicia_em: { required },
        termina_em: {},
      },
    }
  },
}
</script>
